/* eslint-disable */
import { useEffect, useState } from "react";
import { Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ChatModule from "../Chat";
import Datatable from "../../components/features/Datatable";
import { hasAuthority } from "../../../utils/authorities";
import {
  getApprovedLSMLogisticsListing,
  selectManufactureProductList,
} from "../../slices/manufacturer";

import Filter from "./Filter";

const filterConfig = {
  phase_type: {
    label: "Type",
    enum: {
      1: "Trial",
      2: "PMS",
      3: "Commercial",
    },
  },
};

const Manufacturer = () => {
  const navigate = useNavigate();
  const LoginData = useSelector((state) => state.loginData);
  const bmr_permissions = LoginData?.bmr_permissions || [];
  const dispatch = useDispatch();

  const manufactureProductData = useSelector(selectManufactureProductList);

  const tableData = {
    items: manufactureProductData?.items || [],
    total_count: manufactureProductData?.pageDetails?.total_count || 0,
    page: manufactureProductData?.pageDetails?.page || 1,
    per_page: manufactureProductData?.pageDetails?.per_page || 10,
  };

  const handleServerSideChange = async (params) => {
    try {
      await dispatch(getApprovedLSMLogisticsListing(params));
 
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    handleServerSideChange();
  }, []);

  const columns = [
    {
      id: "subject_code",
      name: "ID",
      selector: (row) => (row.patient_id ? row.patient_id : "N/A"),
      sortable: true,
    },
    {
      id: "subject_name",
      name: "Subject Name",
      selector: (row) => (row.subject_name ? row.subject_name : "N/A"),
      sortable: true,
    },
    {
      id: "product/phase",
      name: "Product/Phase",
      selector: (row) =>
        row.product && row.phase ? `${row.product}/${row.phase}` : "N/A",
      sortable: true,
    },
    {
      id: "phase_type",
      name: "Type",
      selector: (row) => (row.phase_type ? row.phase_type : "N/A"),
      sortable: true,
    },
    {
      id: "hospital_name",
      name: "Hospital",
      selector: (row) => (row.hospital_name ? row.hospital_name : "N/A"),
      sortable: true,
    },
    {
      id: "manufacturing_status",
      name: "Manufacturing Status",
      selector: (row) =>
        row.manufacturing_status ? (
          row.manufacturing_status === "Completed" ? (
            <p className="text-[#00B278] font-roboto font-normal text-[14px] leading-[100%] tracking-[0%]">
              {row?.manufacturing_status}
            </p>
          ) : row.manufacturing_status === "Rejected" ||
            row.manufacturing_status === "Failed" ||
            row.manufacturing_status === "Pending" ? (
            <p className="text-[#FF2023] font-roboto font-normal text-[14px] leading-[100%] tracking-[0%]">
              {row?.manufacturing_status}
            </p>
          ) : (
            <p className="text-gray-400 font-roboto font-normal text-[14px] leading-[100%] tracking-[0%]">
              {row?.manufacturing_status}
            </p>
          )
        ) : (
          "N/A"
        ),
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <Button
          onClick={() =>
            navigate(
              `/bmr/manufacturer_view/${row?.qr_code_generated_id}/${row?.id}`,
              {
            state: [
            { name: "Manufacturer", path: location.pathname },
            {
              name: "Details",
              path:  `/bmr/manufacturer_view/${row?.qr_code_generated_id}/${row?.id}`,
            },
            ]
              }
            )
          }
          key={row?.subject_id}
          size="small"
          className="!w-[100px]"
        >
          View Details
        </Button>
      ),
    },
  ];

  return (
    <Grid
      container
      className="mt-4 ml-0 mr-3 mainDiv"
      rowSpacing={4.5}
      columnSpacing={2.75}
    >
      <Grid item xs={12} sx={{ mt: -2.25 }}>
        {hasAuthority(
          ["product-manufacturing-process-listing", "product-manufacturing-lead-process-listing"],
          bmr_permissions
        ) && (
            <div>
              <Datatable
                columns={columns}
                data={tableData}
                title="Subject"
                FilterComponent={Filter}
                onServerSideChange={handleServerSideChange}
                remote={true}
                filterConfig={filterConfig}
              />
              <ChatModule />
            </div>
          )}
      </Grid>
    </Grid>
  );
};

export default Manufacturer;
